import { useEffect, useState } from "react";
import api from "@/lib/api";

const ACTION_CLS = {
  create: "bg-emerald-50 text-emerald-700 border border-emerald-200",
  update: "bg-sky-50 text-sky-700 border border-sky-200",
  delete: "bg-red-50 text-red-700 border border-red-200",
  assign: "bg-violet-50 text-violet-700 border border-violet-200",
};

export default function AuditLog() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/audit-logs").then((r) => setItems(r.data)); }, []);

  return (
    <div className="space-y-5" data-testid="audit-page">
      <div>
        <h2 className="text-2xl font-semibold">Audit Log</h2>
        <p className="text-sm text-slate-500">Every create, update, delete and assignment.</p>
      </div>
      <div className="bg-white border border-slate-200 rounded-lg overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-500 uppercase text-xs tracking-widest">
            <tr>
              <th className="text-left px-4 py-3">Time</th>
              <th className="text-left px-4 py-3">User</th>
              <th className="text-left px-4 py-3">Action</th>
              <th className="text-left px-4 py-3">Entity</th>
              <th className="text-left px-4 py-3">Meta</th>
            </tr>
          </thead>
          <tbody>
            {items.map((a) => (
              <tr key={a.id} className="border-t border-slate-100 hover:bg-slate-50">
                <td className="px-4 py-3 text-xs text-slate-500">{new Date(a.timestamp).toLocaleString()}</td>
                <td className="px-4 py-3">{a.user_email}</td>
                <td className="px-4 py-3"><span className={`text-xs px-2 py-0.5 rounded-full ${ACTION_CLS[a.action] || "bg-slate-50 text-slate-700"}`}>{a.action}</span></td>
                <td className="px-4 py-3 capitalize">{a.entity} <span className="text-xs text-slate-400">{a.entity_id?.slice(0, 8)}</span></td>
                <td className="px-4 py-3 text-xs text-slate-500">{Object.keys(a.meta || {}).length ? JSON.stringify(a.meta) : "—"}</td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={5} className="text-center text-slate-400 py-10">No audit entries yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
